// DSC21 (docs/build-briefs/DSC21-local-vs-published-discounts.md; P0.21): the words for who owns a discount's
// definition. The server derives the kind from the publication link; a row from an older server has none, and is
// read from `network_publication_id` so the label is never blank.

import type { DiscountKind } from "./api.ts";

export function discountKindOf(row: { kind?: DiscountKind | undefined; network_publication_id?: string | null | undefined }): DiscountKind {
  if (row.kind !== undefined) return row.kind;
  return typeof row.network_publication_id === "string" && row.network_publication_id !== "" ? "corporate" : "local";
}

export function discountKindLabel(row: Parameters<typeof discountKindOf>[0] | DiscountKind): string {
  const kind = typeof row === "string" ? row : discountKindOf(row);
  return kind === "corporate" ? "Corporate" : "Local";
}
